var _style, _feBlend, _feBlend2, _feBlend3, _feBlend4, _g, _g2, _polygon, _path, _polygon2, _path2, _g3, _path3, _feBlend5, _g4, _g5, _path4, _g6, _circle, _g7, _path5, _circle2, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrashed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 469.21 469.21",
    style: {
      enableBackground: "new 0 0 469.21 469.21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter_00000011723628771281533870000014352766949922118324_);}\n\t.st2{mask:url(#SVGID_1_);fill:url(#SVGID_00000103250616546872124600000010973900907302010507_);}\n\t.st3{fill:url(#SVGID_00000050629819249180296890000018245248516975804592_);}\n\t.st4{filter:url(#Adobe_OpacityMaskFilter_00000087399140055368599370000016916885616894274959_);}\n\t.st5{filter:url(#Adobe_OpacityMaskFilter_00000174601097513303451290000007480523577297049494_);}\n\n\t\t.st6{mask:url(#SVGID_00000085971573366491263810000017476052720119057810_);fill:url(#SVGID_00000133498335796149417210000000473080356841198733_);}\n\t.st7{fill:url(#SVGID_00000043454889557898127390000016325966192645593737_);}\n\t.st8{fill:#D8E2F4;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:#FFAA9D;}\n\t.st11{fill:#0B2252;}\n\t.st12{fill:url(#SVGID_00000150072691359589221790000008770256588452427197_);}\n\t.st13{fill:url(#SVGID_00000023265391946640169450000011988515976047109018_);}\n\t.st14{fill:url(#SVGID_00000078747952237088959380000010655280699335332263_);}\n\t.st15{fill:#FF9F91;}\n\t.st16{fill:#14336A;}\n\t.st17{fill:url(#SVGID_00000041261417805643950540000006857303579968159639_);}\n\t.st18{filter:url(#Adobe_OpacityMaskFilter_00000088832820019154817080000006708852582164470147_);}\n\n\t\t.st19{mask:url(#SVGID_00000164484819348139775120000016119944067152676235_);fill:url(#SVGID_00000052102889881642456490000013133529462212308146_);}\n\t.st20{fill:#E0E9F3;}\n\t.st21{opacity:0.72;fill:url(#SVGID_00000102510111450049852410000011559554629713031091_);}\n\t.st22{fill:#3FB790;}\n\t.st23{fill:#34916F;}\n\t.st24{fill:#90DAD8;}\n\t.st25{fill:#50C6A1;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0.4,
    y: 0.4,
    width: 469.21,
    height: 469.21
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.4,
    y: 0.4,
    width: 469.21,
    height: 469.21,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000156566355938488201540000008542146283484198293_",
    filterUnits: "userSpaceOnUse",
    x: 0.4,
    y: 0.4,
    width: 469.21,
    height: 469.21
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.4,
    y: 0.4,
    width: 469.21,
    height: 469.21,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000156566355938488201540000008542146283484198293_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108293686565439703300000003179226222752363915_",
    gradientUnits: "userSpaceOnUse",
    x1: 235,
    y1: 422.9906,
    x2: 235,
    y2: -46.2164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      mask: "url(#SVGID_1_)",
      fill: "url(#SVGID_00000108293686565439703300000003179226222752363915_)"
    },
    cx: 235,
    cy: 235,
    r: 234.6
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004533933048099615590000010223399045183470984_",
    gradientUnits: "userSpaceOnUse",
    x1: 235,
    y1: 422.9906,
    x2: 235,
    y2: -46.2164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBF3FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000004533933048099615590000010223399045183470984_)"
    },
    cx: 235,
    cy: 235,
    r: 234.6
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000000208497247954478410000000096772388380984976_",
    filterUnits: "userSpaceOnUse",
    x: 1.63,
    y: 245.57,
    width: 466.74,
    height: 167.53
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.63,
    y: 245.57,
    width: 466.74,
    height: 167.53,
    id: "SVGID_00000002346779619123133420000006372591645336952708_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000000208497247954478410000000096772388380984976_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000176758102022848747180000001098912736114682297_",
    filterUnits: "userSpaceOnUse",
    x: 1.63,
    y: 245.57,
    width: 466.74,
    height: 167.53
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.63,
    y: 245.57,
    width: 466.74,
    height: 167.53,
    id: "SVGID_00000002346779619123133420000006372591645336952708_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000176758102022848747180000001098912736114682297_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047748105835770720680000014196019975361965959_",
    gradientUnits: "userSpaceOnUse",
    x1: 235,
    y1: 404.8151,
    x2: 235,
    y2: 270.6555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000002346779619123133420000006372591645336952708_)",
      fill: "url(#SVGID_00000047748105835770720680000014196019975361965959_)"
    },
    d: " M468.37,264.83c-25.85-11.3-59.52-16.7-80.54-8.83c-19.73,7.39-16.55,22.07-36.8,28.13c-32.67,9.78-55.3-24.11-103.91-22.5 c-43.25,1.43-58.24,29.35-90.92,22.5c-20.38-4.27-24.24-17.16-38.74-26.25c-24.31-15.24-70.97-15.08-115.83-6.36 c4.09,58.71,29.76,111.46,69.15,150.37c44.31,8.2,92.51,12.57,139.54,10.83c82.64-3.07,166.22-25.2,223.14-51.55 C451.68,332.66,463.91,299.96,468.37,264.83z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104695438378570504280000010699035493832699776_",
    gradientUnits: "userSpaceOnUse",
    x1: 235,
    y1: 404.8151,
    x2: 235,
    y2: 270.6555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    style: {
      stopColor: "#EBF3FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104695438378570504280000010699035493832699776_)"
    },
    d: "M468.37,264.83 c-25.85-11.3-59.52-16.7-80.54-8.83c-19.73,7.39-16.55,22.07-36.8,28.13c-32.67,9.78-55.3-24.11-103.91-22.5 c-43.25,1.43-58.24,29.35-90.92,22.5c-20.38-4.27-24.24-17.16-38.74-26.25c-24.31-15.24-70.97-15.08-115.83-6.36 c4.09,58.71,29.76,111.46,69.15,150.37c44.31,8.2,92.51,12.57,139.54,10.83c82.64-3.07,166.22-25.2,223.14-51.55 C451.68,332.66,463.91,299.96,468.37,264.83z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M399.43,133.8H342.7c-3.32,0-6.35-1.2-8.7-3.19c-2.9-2.46-4.74-6.14-4.74-10.24v0c0-3.71,1.5-7.07,3.94-9.5 c2.43-2.43,5.79-3.94,9.5-3.94h56.73c3.71,0,7.07,1.5,9.5,3.94c2.43,2.43,3.94,5.79,3.94,9.5v0c0,3.71-1.5,7.07-3.94,9.5 C406.5,132.3,403.14,133.8,399.43,133.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0621 -0.9981 0.9981 0.0621 232.3692 469.8288)",
    className: "st8",
    cx: 366.18,
    cy: 111.27,
    rx: 20.36,
    ry: 20.36
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M136.09,101.27H52.84c-5.44,0-10.37-2.21-13.94-5.78c-3.57-3.57-5.78-8.5-5.78-13.94v0 c0-3.88,1.12-7.5,3.06-10.55c3.5-5.51,9.65-9.16,16.66-9.16h83.25c5.44,0,10.37,2.21,13.94,5.78c3.57,3.57,5.78,8.5,5.78,13.94v0 c0,5.08-1.92,9.71-5.08,13.21C147.13,98.75,141.9,101.27,136.09,101.27z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2538 -0.9673 0.9673 0.2538 -0.8303 135.335)",
    className: "st9",
    cx: 87.3,
    cy: 68.21,
    rx: 29.88,
    ry: 29.88
  }))), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "350.97,421.68 352.29,428.38 329.79,428.38 328.36,421.68  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M352.29,428.38l1.07,5.23c0.07,0.33-0.18,0.64-0.52,0.64h-25.22c-0.31,0-0.51-0.32-0.37-0.6l2.55-5.27 H352.29z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "316.8,421.68 318.12,428.38 295.62,428.38 294.19,421.68  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M318.12,428.38l1.07,5.23c0.07,0.33-0.18,0.64-0.52,0.64h-25.22c-0.31,0-0.51-0.32-0.37-0.6l2.55-5.27 H318.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104706587024283258380000007433371775544187522_",
    gradientUnits: "userSpaceOnUse",
    x1: -399.2591,
    y1: 426.2651,
    x2: -400.3139,
    y2: 354.8578,
    gradientTransform: "matrix(-1 0 0 1 -77.087 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#14336D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9662,
    style: {
      stopColor: "#0E2253"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104706587024283258380000007433371775544187522_)"
    },
    d: "M353.18,317c0,0-6.66,48.76-4.56,70.66 c2.1,21.9,4.43,36.58,4.43,36.58h-25.63c0,0-6.76-27.49-7.22-43.8c0,0-4.19,21.44-1.63,43.8h-24.93c0,0-6.86-78.15,7.59-107.74 L353.18,317z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139254478281875121570000012981756473253187756_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.4512,
    y1: 267.0391,
    x2: 331.5016,
    y2: 296.0318
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3162DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#173DB8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139254478281875121570000012981756473253187756_)"
    },
    d: "M320.46,241.53 c0,0,24.16,3.84,33.1,24.75c8.94,20.91,5.14,28.2,1.85,31.52c-3.29,3.32-9.92,6.41-9.92,6.41L320.46,241.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083773547947777828250000011686000933352876465_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.5937,
    y1: 272.3336,
    x2: 285.8338,
    y2: 321.8798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3162DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#173DB8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083773547947777828250000011686000933352876465_)"
    },
    d: "M296.27,326.38 c2.61,3.48,57.87,1.27,59.14-7.63s-9.65-64.75-21.25-72.57c-10.85-7.32-18.41-5.91-25.41-4.24c-6.99,1.67-14.74,15.47-11.88,27.42 c2.86,11.95,5.48,12.79,5.15,24.74C301.64,308.61,293.59,322.79,296.27,326.38z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M299.11,226.39l-1.11,7.98l1.2,0.11c0,0,0.13,6.74,4.94,6.27c1.38-0.13,3.24-1.06,3.7-0.77 c0.55,0.34,0.58,2.19,0.65,2.73c0.26,2.07,7.52,0.91,6.64-1.28c-0.84-2.08-2.11-4.95-1.68-5.64c1.51-2.43,2.64-8.79-3.54-11.73 C304.98,221.71,299.5,223.66,299.11,226.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M315.12,241.43c-0.84-2.08-2.11-4.95-1.68-5.64c0,0-3.22,3.83-5.8,4.15c-0.01,0-0.01,0-0.01,0 c0.08,0.01,0.16,0.02,0.21,0.05c0.55,0.34,0.58,2.19,0.65,2.73C308.74,244.78,316,243.63,315.12,241.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M309.43,231.66c3.08-0.14,0.37,6.34,3.72,6.53c3.35,0.19,6.56-6.78,4.82-12.68 c-1.74-5.9-6.41-6.16-10.92-5.95c-4.51,0.21-10.17,1.54-10.58,4.88c-0.99,8.03,9.35,2.48,9.68,4.97 c0.25,1.93,0.33,7.42-1.62,7.31c-1.95-0.12-3.73-1.96-5.31-1.74c-0.91,0.13-4.65,10.36,1.65,11.5c6.22,1.13,8.5-4.21,7.74-8.89 C307.89,233.13,307.93,231.72,309.43,231.66z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M259.11,304.08c0,0-10.29-4.47-13.58-7.07c-3.29-2.6-4.69-3.8-4.05-4.55c0.64-0.75,9.13,1.62,9.81,0.92 c0.68-0.7-0.2-2.08,0.57-2.87c0.77-0.79,6.68,3.78,7.85,3.2C260.89,293.12,260.4,302.93,259.11,304.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001647568446622175480000018029127684783502779_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.0742,
    y1: -494.8408,
    x2: 347.3542,
    y2: -455.2834,
    gradientTransform: "matrix(0.6982 -0.7159 0.7159 0.6982 376.2058 891.9901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3162DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#173DB8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001647568446622175480000018029127684783502779_)"
    },
    d: "M258.54,291.1l-0.99,13.29 c0,0,26.15,12.79,48.06-2.63c21.91-15.42,31.9-40.56,21.43-53.71c-8.27-10.39-20.74,11.4-24.99,19.63 C297.8,275.92,288.88,290.61,258.54,291.1z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000008127664260491554800000006450095896171393441_",
    filterUnits: "userSpaceOnUse",
    x: 12.83,
    y: 138.14,
    width: 190.78,
    height: 204.91
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 12.83,
    y: 138.14,
    width: 190.78,
    height: 204.91,
    id: "SVGID_00000051349237349467582950000000814884485290048680_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000008127664260491554800000006450095896171393441_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049904104348610751730000011631893436811876484_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.5895,
    y1: 160.6712,
    x2: 154.5895,
    y2: 327.6712
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50C6A1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#50C6A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000051349237349467582950000000814884485290048680_)",
      fill: "url(#SVGID_00000049904104348610751730000011631893436811876484_)"
    },
    d: " M12.83,138.14c0,0,57.57,25.95,56.65,36.36c-0.92,10.4-16.39,18.03,0.01,34.68s40.22,26.36,41.84,46.47 c1.62,20.11-3.7,39.07,12.02,49.94c15.72,10.87,19.65,37.46,19.65,37.46h20.11c0,0,8.39-23.66,1.35-33.31 c-7.04-9.65-23.68-27.81-14.85-47.47c8.82-19.67,27.23-7.31,14.37-34.29c-12.86-26.98,33.58-15.76,38.91-44.33 c5.33-28.57-20.95-23.57-14.86-45.5H12.83z"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M197.66,361.79l10.75,20.94c1.4,2.74,5.16,3.11,7.08,0.71l10.6-13.29c1.81-2.27,2.12-5.39,0.79-7.97 l-15.35-29.88c-1.92-3.74-7.18-3.96-9.41-0.39l0,0c-1.02,1.63-1.1,3.68-0.2,5.39l4.38,8.36l-8.34,11.76 C197.06,358.69,196.94,360.38,197.66,361.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M212.19,387.6c-0.23,0-0.46-0.01-0.68-0.03c-2.31-0.23-4.32-1.6-5.38-3.66l-10.75-20.94c0,0,0,0,0,0 c-1.16-2.27-0.97-4.97,0.5-7.04l7.42-10.48l-3.65-6.96c-1.31-2.5-1.2-5.55,0.3-7.94c1.54-2.47,4.2-3.87,7.11-3.75 c2.91,0.12,5.44,1.74,6.77,4.33L229.17,361c1.79,3.48,1.36,7.7-1.07,10.75l-10.6,13.29C216.2,386.67,214.25,387.6,212.19,387.6z  M199.95,360.61l10.75,20.94c0.37,0.73,1.05,0.87,1.32,0.9c0.27,0.03,0.96,0.02,1.47-0.62l10.6-13.29 c1.18-1.48,1.38-3.52,0.52-5.2l-15.35-29.88c-0.68-1.33-1.91-1.52-2.41-1.54c-0.5-0.02-1.74,0.07-2.53,1.34 c-0.53,0.85-0.57,1.94-0.11,2.83l4.39,8.36c0.45,0.86,0.38,1.89-0.18,2.68l-8.34,11.76C199.71,359.4,199.66,360.06,199.95,360.61 L199.95,360.61z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M150.72,381l11.59,20.48c1.51,2.68-0.24,6.02-3.3,6.31l-16.92,1.56c-2.89,0.27-5.67-1.19-7.1-3.71 l-16.55-29.23c-2.07-3.66,0.64-8.18,4.84-8.08l0,0c1.92,0.04,3.68,1.11,4.61,2.79l4.58,8.25l14.41-0.51 C148.46,378.8,149.94,379.62,150.72,381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M141.42,411.95c-3.56,0-6.89-1.91-8.66-5.05l-16.55-29.23c-1.43-2.53-1.4-5.54,0.1-8.04 c1.49-2.5,4.13-3.96,7.04-3.88c2.83,0.06,5.43,1.64,6.8,4.11l3.81,6.88l12.83-0.45c2.56-0.1,4.91,1.23,6.16,3.45l11.59,20.48 c1.14,2.02,1.18,4.45,0.11,6.51c-1.08,2.06-3.1,3.41-5.41,3.62l-16.92,1.56C142.02,411.93,141.72,411.95,141.42,411.95z  M123.15,370.88c-1.44,0-2.18,0.96-2.43,1.38c-0.26,0.43-0.77,1.56-0.04,2.86l16.55,29.23c0.93,1.64,2.75,2.59,4.63,2.42 l16.92-1.56c0.82-0.08,1.2-0.65,1.32-0.89c0.13-0.24,0.38-0.88-0.03-1.59l-11.59-20.48l0,0c-0.31-0.54-0.87-0.86-1.51-0.84 l-14.41,0.51c-0.96,0.04-1.87-0.48-2.34-1.32l-4.58-8.25c-0.49-0.88-1.42-1.44-2.42-1.47 C123.2,370.88,123.18,370.88,123.15,370.88z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M164.4,409.63h62.28l-43.54-84.79c-2.02-3.92-6.31-6.12-10.67-5.46c-4.83,0.73-11.74,2.61-20.15,7.23 c-7.75,4.25-12.93,8.21-16.28,11.26c-3.42,3.11-4.31,8.14-2.19,12.26L164.4,409.63z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M171.79,434.24h72.79l-50.89-99.1c-2.36-4.59-7.37-7.15-12.47-6.38c-5.65,0.85-13.72,3.05-23.55,8.45 c-9.05,4.97-15.11,9.59-19.03,13.16c-4,3.64-5.03,9.52-2.56,14.33L171.79,434.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M244.58,436.81h-72.79c-0.96,0-1.85-0.54-2.29-1.4l-35.72-69.55c-3-5.84-1.72-13,3.12-17.4 c5.13-4.67,11.7-9.22,19.52-13.52c8.44-4.63,16.65-7.57,24.41-8.74c6.19-0.93,12.28,2.18,15.14,7.75l50.89,99.1 c0.41,0.8,0.37,1.75-0.09,2.51C246.31,436.35,245.48,436.81,244.58,436.81z M173.36,431.67h67.01l-48.97-95.35 c-1.85-3.6-5.79-5.62-9.8-5.02c-4.92,0.74-12.84,2.75-22.7,8.16c-7.47,4.1-13.7,8.41-18.53,12.81c-3.12,2.85-3.95,7.47-2.01,11.25 L173.36,431.67z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 176.66,
    cy: 382.07,
    r: 17.62
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155836501077772951370000007974475709414894780_",
    gradientUnits: "userSpaceOnUse",
    x1: 2096.6555,
    y1: 367.3948,
    x2: 2108.824,
    y2: 399.8618,
    gradientTransform: "matrix(-1 0 0 1 2278.8149 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    style: {
      stopColor: "#EBF3FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.72,
      fill: "url(#SVGID_00000155836501077772951370000007974475709414894780_)"
    },
    cx: 176.66,
    cy: 382.07,
    r: 13.36
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M266.24,395.51c2.44,0.81,0.61,4.24,0.61,6.67c0,2.42,1.21,9.09-1.21,10.3c-2.42,1.21-6.06,3.64-6.06,6.06 c0,2.42-0.61,5.45-3.03,6.67c-2.42,1.21-4.85,1.21-4.85,3.03s1.21,2.42,0.61,4.24c-0.61,1.82-1.82,2.42-1.21,3.03h-15.76 c0,0-3.03-4.85-2.42-7.88c0.61-3.03,3.64-3.03,4.24-5.45c0.61-2.42,3.64-3.03,3.64-5.45c0-2.42,1.21-6.06,3.03-7.27 c1.82-1.21,5.45,0,6.67-2.42c1.21-2.42,0-4.85,1.82-6.06c1.82-1.21,5.45,0.61,7.27-1.21C261.4,397.93,264.43,394.9,266.24,395.51 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M263.81,407.85c-0.05-0.16-0.21-0.25-0.38-0.21c-0.03,0.01-2.8,0.8-4.76,0.77c1.37-5.17,4.3-6.24,4.33-6.25 c0.16-0.05,0.24-0.22,0.19-0.38c-0.05-0.16-0.22-0.24-0.38-0.19c-0.16,0.05-3.82,1.35-5.05,8.11c-0.29,1.57-1.3,3.06-2.68,4.48 c-1.17-1.16-1.53-4.86-1.57-6.26c0-0.16-0.14-0.29-0.3-0.29c0,0-0.01,0-0.01,0c-0.17,0-0.3,0.14-0.29,0.31 c0.01,0.22,0.16,5.07,1.75,6.67c-1.53,1.49-3.43,2.93-5.31,4.34c-2.01,1.51-3.95,2.98-5.44,4.48c-0.24-0.6-0.29-2.54-0.1-4.57 c0.02-0.17-0.11-0.31-0.27-0.33c-0.17-0.01-0.31,0.11-0.33,0.27c-0.12,1.29-0.3,4.11,0.28,5.07c-0.99,1.08-1.74,2.19-2.09,3.35 c-0.05,0.16,0.04,0.33,0.2,0.38c0.03,0.01,0.06,0.01,0.09,0.01c0.13,0,0.25-0.08,0.29-0.22c0.74-2.47,3.47-4.74,6.57-7.09 c1.69,1.58,6.26,1.84,6.46,1.85c0.01,0,0.01,0,0.02,0c0.16,0,0.29-0.13,0.3-0.29c0.01-0.17-0.12-0.31-0.29-0.32 c-0.05,0-4.43-0.26-6-1.62c0.23-0.17,0.45-0.34,0.68-0.51c3.92-2.96,7.98-6.01,8.64-9.63c0.05-0.28,0.11-0.53,0.17-0.79 c0.09,0,0.17,0.01,0.26,0.01c2.04,0,4.69-0.76,4.81-0.8C263.76,408.17,263.85,408.01,263.81,407.85z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M229.94,396.72c-3.16,1.58,0,8.48-0.61,10.91c-0.61,2.42-2.42,4.24-1.82,6.67c0.61,2.42,1.82,4.24,1.82,6.67 c0,2.42-3.64,4.85-3.03,9.09c0.61,4.24,2.42,5.45,2.42,5.45h13.33c0,0,1.21-1.21,1.21-3.64c0-2.42-3.03-4.85-2.42-6.06 c0.61-1.21,3.03-3.64,2.42-7.88c-0.61-4.24-2.42-4.24-3.03-6.67c-0.61-2.42,0.61-3.64,0-5.45c-0.61-1.82-3.64-3.64-4.24-4.85 C235.39,399.75,233.57,394.9,229.94,396.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M240.13,418c-0.13-0.11-0.32-0.09-0.43,0.04c-0.6,0.72-2.15,2.47-3.14,3.26c0.03-0.42,0.04-0.84,0.04-1.25 c0-1.89,0-3.8-0.09-5.65c0-0.01,0-0.02,0-0.04c-0.08-1.65-0.23-3.24-0.52-4.68c-0.61-3.06-3.56-7.21-3.69-7.39 c-0.1-0.14-0.29-0.17-0.42-0.07c-0.14,0.1-0.17,0.29-0.07,0.42c0.03,0.04,3,4.22,3.59,7.15c0.22,1.12,0.36,2.34,0.45,3.61 c-1.1-1.14-2.95-2.07-3.05-2.12c-0.15-0.08-0.33-0.02-0.41,0.14c-0.07,0.15-0.01,0.33,0.13,0.41c0.03,0.01,2.69,1.36,3.38,2.65 c0.09,1.81,0.09,3.71,0.09,5.57c0,1.6-0.24,3.34-0.45,4.87c-0.2,1.46-0.37,2.69-0.31,3.54c-1.06-0.61-2.82-1.32-3.07-1.42 c-0.15-0.06-0.33,0.01-0.39,0.17c-0.06,0.15,0.01,0.33,0.17,0.39c0.81,0.33,3,1.26,3.5,1.73c0.68,1.38,1.77,4.22,1.86,6.19 c0.01,0.16,0.14,0.29,0.3,0.29c0,0,0.01,0,0.01,0c0.17-0.01,0.3-0.15,0.29-0.32c-0.1-2.08-1.25-5.08-1.95-6.48 c-0.29-0.59-0.06-2.25,0.18-4c0.13-0.92,0.26-1.91,0.35-2.91c1.22-0.74,3.57-3.54,3.67-3.67 C240.28,418.3,240.26,418.11,240.13,418z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M261.37,436.81h-119.4c-1.42,0-2.57-1.15-2.57-2.57c0-1.42,1.15-2.57,2.57-2.57h119.4 c1.42,0,2.57,1.15,2.57,2.57C263.94,435.66,262.79,436.81,261.37,436.81z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 87.26,
    cy: 290.39,
    r: 6.12
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M190.02,220.87c0,2.5-2.03,4.53-4.53,4.53c-2.5,0-4.53-2.03-4.53-4.53c0-2.5,2.03-4.53,4.53-4.53 C188,216.35,190.02,218.37,190.02,220.87z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M50.99,186.91c0,1.78-1.44,3.22-3.22,3.22c-1.78,0-3.22-1.44-3.22-3.22c0-1.78,1.44-3.22,3.22-3.22 C49.55,183.69,50.99,185.13,50.99,186.91z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrashed);
export default __webpack_public_path__ + "static/media/crashed.4c0c931890ce57af8bc2a11959dd6f77.svg";
export { ForwardRef as ReactComponent };